import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { Label } from "components/Form";
import { Text, FontWeight } from '../Text';
import { Breakpoints } from 'constants/Breakpoints';

export const Container = styled.div`
background: ${Colors.WHITE};

`;

export const HeaderContainer = styled.div`
margin-top: 30px;
border-radius: 20px 20px 0px 0px;
border: 1px solid ${Colors.SECONDARY};
background: ${Colors.SECONDARY};
padding: 10px 10px 0px 10px;
margin-bottom: 0px;

`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

export const ListDetail = styled.div`
border-radius: 0px 0px 20px 20px;
border: 1px solid ${Colors.SECONDARY};
background: ${Colors.WHITE};
padding: 0px 10px 10px 10px;
box-shadow: 0px 17px 17px 6px #5f5f5f1a;

`;

export const ItemContainer = styled.div`
  margin-top: 23px;
  margin-bottom: 26px;
  background: ${Colors.WHITE};
  padding: 0px 10px 0px 10px;
`;

export const ColStyled = styled.div`
  @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) {
    flex-direction: column;
  }

  display: flex;
  flex-direction: row;
`

export const Ball = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: ${({ color }) => color};
  padding-left: 10px;
`;

export const Label1 = styled(Label)`
  color: ${Colors.GRAY[0]};
`;

